import type { Comprobante } from '../api';

/**
 * ARCA rechazó el pedido (KAN-145): `resultado: RECHAZADO`. **No es un error
 * del sistema** — el servicio funcionó, ARCA dijo que no — así que esto no se
 * muestra como el cartel rojo genérico de `mensajeDeEmision`, sino con los
 * códigos y textos tal cual los mandó ARCA: son la explicación real de lo que
 * hay que corregir, no algo para traducir.
 *
 * No hay botón acá: el formulario que la monta sigue abajo, editable, con los
 * datos que la persona ya cargó — corregir no es empezar de cero.
 */
export function ResultadoRechazado({ comprobante }: { comprobante: Comprobante }) {
  return (
    <section aria-labelledby="resultado-rechazado-titulo" role="alert">
      <h2 id="resultado-rechazado-titulo">ARCA rechazó el comprobante</h2>
      <p>No se emitió nada: no se consumió número y no se registró ningún comprobante.</p>

      {comprobante.errores.length > 0 ? (
        <ul>
          {comprobante.errores.map((e) => (
            <li key={e}>{e}</li>
          ))}
        </ul>
      ) : null}

      {comprobante.observaciones.length > 0 ? (
        <>
          <p>Observaciones:</p>
          <ul>
            {comprobante.observaciones.map((o) => (
              <li key={o}>{o}</li>
            ))}
          </ul>
        </>
      ) : null}

      <p className="nota">Corregí los datos abajo y volvé a emitir.</p>
    </section>
  );
}
